import CompanyPageHeader from './CompanyPageHeader';

export default CompanyPageHeader;
